import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import {
    fetchCardAccountApplication,
    fetchCardAccountApplicationSuccess,
    fetchCardAccountApplicationError,
} from '@perpay-web/fintech/actions/entities/cardAccountApplications';
import {
    fetchPartnerHostedCardApplication as fetchPartnerHostedCardApplicationAction,
    fetchPartnerHostedCardApplicationSuccess,
    fetchPartnerHostedCardApplicationError,
} from '@perpay-web/fintech/actions/ui/partnerHostedCardApplication';
import { getCardApplicationStepFromStatus } from '@perpay-web/fintech/components/screens/CardApplication/CardApplicationSteps';
import { cardApplicationSetSteps } from '@perpay-web/fintech/components/screens/CardApplication/useCardApplicationContext';
import { COMPLETE } from '@perpay-web/fintech/constants/cardAccountApplicationStatuses';
import { APPLICATION_STEP } from '@perpay-web/fintech/constants/steps/cardPartnerOnboardingSteps';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';
import { replace } from '@perpay-web/services/router';

export const fetchPartnerHostedCardApplication = (action$, state$) =>
    action$.pipe(
        ofType(fetchPartnerHostedCardApplicationAction().type),
        exhaustMap(() =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: () => [fetchCardAccountApplication()],
                waitFor: [fetchCardAccountApplicationSuccess().type],
                waitForDispatch: (state, results) => {
                    const cardAccountApplication = results[0].payload;
                    const returnActions = [
                        fetchPartnerHostedCardApplicationSuccess(
                            cardAccountApplication,
                        ),
                    ];
                    if (cardAccountApplication.status === COMPLETE) {
                        replace(paths.dashboard.path);
                    } else if (cardAccountApplication.status) {
                        returnActions.push(
                            cardApplicationSetSteps(
                                getCardApplicationStepFromStatus(
                                    cardAccountApplication.status,
                                ),
                            ),
                        );
                    } else {
                        returnActions.push(
                            cardApplicationSetSteps(APPLICATION_STEP),
                        );
                    }
                    // If there is no application, then they are already on the right (Application) step of the flow.
                    return returnActions;
                },
                errors: [fetchCardAccountApplicationError().type],
                errorDispatch: (result) => {
                    const error = result.payload;
                    return [fetchPartnerHostedCardApplicationError(error)];
                },
            }),
        ),
    );
